import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logomark from "@/components/sections/Logomark";

const links = [
  { label: "Services", id: "services" },
  { label: "Features", id: "features" },
  { label: "Showcase", id: "portfolio" },
  { label: "Contact", id: "contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "py-2" : "py-4"}`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <nav
          className={`surface rounded-2xl flex items-center justify-between px-4 sm:px-6 h-14 sm:h-16 transition-all ${
            scrolled ? "shadow-[0_18px_40px_-20px_rgba(10,15,30,0.18)]" : ""
          }`}
        >
          <button onClick={() => scrollTo("hero")} data-testid="navbar-logo" className="flex items-center gap-3">
            <Logomark size={36} />
            <div className="text-left">
              <div className="font-display text-[17px] sm:text-[19px] font-bold tracking-tight text-[#0a0e1a] leading-none">
                ARJ <span className="text-[#0066ff]">TEAM</span>
              </div>
              <div className="hidden sm:block text-[10px] text-[#6b7280] font-mono-d uppercase tracking-[0.2em] mt-1">
                Studio
              </div>
            </div>
          </button>

          <div className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-link-${l.id}`}
                onClick={() => scrollTo(l.id)}
                className="relative px-3 py-2 text-sm font-medium text-[#475569] hover:text-[#0a0e1a] transition-colors group"
              >
                {l.label}
                <span className="absolute left-3 right-3 -bottom-0.5 h-px bg-gradient-to-r from-[#0066ff] to-[#10b981] scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-300" />
              </button>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <button
              data-testid="navbar-cta-start-project"
              onClick={() => scrollTo("contact")}
              className="btn-primary hidden sm:inline-flex !py-2 !px-4 !text-sm"
            >
              Start Project
            </button>
            <button
              data-testid="navbar-mobile-toggle"
              className="md:hidden p-2 rounded-lg btn-ghost !py-2 !px-2"
              onClick={() => setOpen((s) => !s)}
              aria-label="Toggle menu"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </nav>

        {open && (
          <div className="md:hidden mt-2 surface rounded-2xl p-2" data-testid="mobile-menu">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-link-${l.id}`}
                onClick={() => scrollTo(l.id)}
                className="block w-full text-left px-4 py-3 rounded-xl font-medium text-[#1f2937] hover:bg-[#f4f6fa]"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-cta-start-project"
              onClick={() => scrollTo("contact")}
              className="btn-primary w-full mt-1 !py-3 !text-sm justify-center"
            >
              Start Project
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
